module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_t2_b2_dark 1.8025d41d.svg";